export default {
  about: {
    title: "À propos de Nesto",
    section1_title: "Pourquoi nous avons lancé Nesto",
    section1_p1:
      "Pour la plupart d'entre nous, l'achat d'une propriété sera la plus importante dépense de notre vie. Et pourtant, en raison de la complexité du processus, nous nous résignons trop souvent à une hypothèque sous-optimale et laissons des milliers de dollars d'économies potentielles sur la table.",
    section1_p2: "Le marché hypothécaire actuel ne sert pas les consommateurs:",
    section1_p3:
      "• Il y a un <strong>manque de transparence sur les taux hypothécaires offerts</strong> - accéder au meilleur taux et négocier avec plusieurs institutions financières est un travail à temps plein.",
    section1_p4:
      "• Les banques offrent des <strong>taux élevés</strong>, dans l'espoir de convertir des clients captifs",
    section1_p5:
      "• Les <strong>courtiers hypothécaires ont des intérêts divergents de ceux de leur clients</strong>: obtenir le meilleur produit hypothécaire, tout en maximisant leur commission (par exemple, en favorisant un certain prêteur pour atteindre leur objectif de volume)",
    section1_p6:
      "• Dans l'ensemble, le processus est <strong>opaque, complexe, fastidieux et stressant</strong>",
    section1_p7:
      "Chez <strong>Nesto</strong>, nous croyons que nous pouvons résoudre ces problèmes en vous <strong>offrant une solution hypothécaire transparente</strong> qui répond aux défis auxquels notre industrie est confrontée.",

    section2_title: "Notre Vision",
    section2_p1:
      "Ultimement, la vision de Nesto est de donner à tous les Canadiens accès à la propriété.",
    section2_p2:
      "Nous soutenons notre Vision en <strong>offrant à nos clients le meilleur produit hypothécaire possible</strong> pour l’achat le plus important de leur vie.",

    section3_title: "Notre Solution",
    section3_p1: "Une vraie transparence signifie",
    section3_p2:
      "Avoir accès à des <strong>taux provenant de plus de 20 institutions financières</strong> de confiance. Notre technologie vous fera économiser des heures de recherche en ligne, d'appels téléphoniques et de visites en succursales.",
    section3_p3:
      "Des <strong>Courtiers Hypothécaires indépendants qui travaillent pour vous, pas pour les banques.</strong> Votre Courtier Hypothécaire vous guidera dans la sélection du bon produit pour votre propre situation. En choisissant la meilleure offre, ils vous diront combien la banque fait, et ce qu'il y en est pour nous.",
    section3_p4:
      "Gérer la complexité de l'application pour vous. Votre Courtier Hypothécaire prend en charge votre demande. Notre technologie simplifie l'application et accélère le processus, en veillant à ce que votre prêt hypothécaire soit émis le plus rapidement possible",
    section3_p5:
      "En bref, Nesto vous fera économiser de l'argent en vous offrant une vue exhaustive des taux offerts, en fournissant des conseils indépendants, et en accélérant votre application."
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/fr/about.js